import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installBreadcrumbTracking, isIgnorableClientError, reportError } from './errorReporting';

// ---------------------------------------------------------------------------
// Global exception reporting — sends uncaught JS errors to the server so they
// appear in the admin error log (Admin → System → Error log).
// ---------------------------------------------------------------------------
installBreadcrumbTracking();

(function installGlobalErrorReporter() {
  window.addEventListener('error', (event) => {
    if (isIgnorableClientError(event.message, {
      name: event.error?.name,
      sourceFile: event.filename,
    })) return;
    reportError({
      error_type: 'global',
      message:    String(event.message || 'Unknown error').slice(0, 2000),
      stack:      event.error && event.error.stack ? String(event.error.stack).slice(0, 5000) : null,
      // url = current SPA route (not the JS bundle filename)
      url:        window.location.href,
      line_no:    event.lineno  || null,
      col_no:     event.colno   || null,
      extra: {
        source_file: event.filename || null,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason instanceof Error
      ? reason.message
      : String(reason ?? 'Unhandled promise rejection');
    if (isIgnorableClientError(message, {
      name: reason instanceof Error ? reason.name : undefined,
    })) return;
    reportError({
      error_type: 'promise',
      message:    message.slice(0, 2000),
      stack:      reason instanceof Error && reason.stack ? String(reason.stack).slice(0, 5000) : null,
      url:        window.location.href,
    });
  });
})();

// Chrome fires this when ResizeObserver callbacks affect layout in the same frame — benign in dev.
if (process.env.NODE_ENV === 'development') {
  const resizeObserverLoopRe = /^ResizeObserver loop/;
  window.addEventListener(
    'error',
    (event) => {
      if (resizeObserverLoopRe.test(event.message || '')) {
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(({ name, value, id, delta, rating }) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, {
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      metric_id: id,
      metric_value: value,
      metric_delta: delta,
      metric_rating: rating,
      non_interaction: true,
    });
  }
});
